import "./ClientDashboardFeaturesComponent.scss";
import template from "./ClientDashboardFeaturesComponent.html";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {ReplaySubject} from "rxjs";
import {CurrentUserService} from "../../../../services/user/CurrentUserService";
import {FeatureNames} from "../../../../types/UserConfig";
import {DashboardFeaturesModel} from "./models/DashboardFeatureModel";
import {AccountStore} from "../../../../account/store/AccountStore";
import {isNotNull} from "../../../../js/util/UtilFunctions";

export const ClientFeatures = "tfClientDashboardFeatures";

export function clientFeatures(parentDir: string): IComponentOptions {
    return {
        template,
        bindings: {
            features: "<",
            columns: "<"
        },
        controllerAs: "ctrl",
        controller: ClientDashboardFeaturesComponentController
    };
}

export class ClientDashboardFeaturesComponentController implements IOnInit, IOnDestroy {

    public features: DashboardFeaturesModel | null;

    /* Input Binding */
    public set columns(columns: number | null) {
        if (columns != null && columns > 0) {
            const width = 100 / columns;
            this.columnWidth = `${width}%`;
        } else {
            this.columnWidth = "100%";
        }
    }

    public columnWidth = "100%";
    public currentPortfolioId: number | null = null;

    public hasStrategyBuilder = false;
    public hasCharting = false;
    public hasBacktesting = false;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly accountStore: AccountStore,
                       private readonly currentUserService: CurrentUserService) {
    }

    public $onInit(): void {
        this.accountStore
            .current
            .filter(isNotNull)
            .takeUntil(this.destroyed$)
            .subscribe((p) => this.currentPortfolioId = p.id);
        this.hasStrategyBuilder = this.currentUserService.hasFeature(FeatureNames.SCREEN_STRATEGY_BUILDER);
        this.hasCharting = this.currentUserService.hasFeature(FeatureNames.FEATURE_ADV_CHARTING);
        this.hasBacktesting = this.currentUserService.hasFeature(FeatureNames.SCREEN_BACKTESTING);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
